import styled from 'styled-components'

export const NumbersContainer = styled.div`
  padding: 30px 0;
  position: relative;
  background-color: inherit;
  width: 100%;
  display: flex;
`
export const TimelineContainer = styled.div`
  position: relative;
  max-width: 1200px;
  margin: 0 auto;

  &::after{
    content: '';
    position: absolute;
    width: 1.5px;
    background-color: rgba(102, 102, 102, 1);
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -3px;
  }
`

export const ContentLeft = styled.div`
    padding: 20px 50px;
    position: relative;
    border-radius: 6px;
    color: black;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: end;
    justify-content: center;
    text-align: end;
    color: white;

    @media (max-width: 550px) {
      /* Phones */
      font-size: 0.8em;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      font-size: 0.8em;
    }

    &::after{
    content: '${props => props.number}';
    position: absolute;
    width: 45px;
    height: 45px;
    right: -24px;
    background-image: linear-gradient(rgba(124, 1, 0, 1), rgba(226, 2, 0, 1));
    top: 60px;
    border-radius: 50%;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 1.4em;
    position: absolute;
    color: white;



    
  }
`

export const ContentRight = styled.div`
    padding: 20px 50px;
    position: relative;
    border-radius: 6px;
    color: black;
    display: flex;
    flex-direction: column;
    color: white;
    width: 100%;

    @media (max-width: 550px) {
      /* Phones */
      font-size: 0.8em;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      font-size: 0.8em;
    }
`

export const  ImageContainer = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(90, 112, 139, 0.4);
  border-radius: 12px;
  
    @media (max-width: 550px) {
      /* Phones */
      width: 80px;
      height: 80px;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      width: 80px;
      height: 80px;
    }

  img{
    width: ${props => props.size};
  }
`